import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Layout, Text } from '@loadsmart/miranda-react'

import { hasRfpContract, hasNotes } from 'core/domain/Load'

import { type Load } from '../domain/Load'

export type LoadExtraInformationProps = {
  load: Load
}

export function LoadExtraInformation({ load }: LoadExtraInformationProps) {
  const hasShipperNotes = hasNotes(load)
  const hasContractRfp = hasRfpContract(load)
  const { push: navigate } = useHistory()

  const handleNavigateToContract = useCallback(() => {
    navigate(`/rfp/${load.contract?.rfp?.inviteUUID}`)
  }, [load, navigate])

  if (!hasShipperNotes && !hasContractRfp) return null

  return (
    <Layout.Box
      padding="spacing-6"
      backgroundColor="color-background-primary"
      borderRadius="border-radius-s"
      borderWidth="border-thin"
      borderColor="color-border"
    >
      <Layout.Stack gap="spacing-6">
        {hasShipperNotes && (
          <Layout.Stack gap="spacing-1">
            <Text variant="body-sm">Shipper notes</Text>
            <Text variant="body-md" style={{ textAlign: 'left' }}>
              {load.notes}
            </Text>
          </Layout.Stack>
        )}
        {hasContractRfp && (
          <Layout.Stack gap="spacing-1">
            <Text variant="body-sm">Contract info</Text>
            <Button
              variant="secondary"
              size="small"
              type="button"
              onClick={handleNavigateToContract}
            >
              See contract details
            </Button>
          </Layout.Stack>
        )}
      </Layout.Stack>
    </Layout.Box>
  )
}
